import { cx } from "@/utils/cx";
import { Plus } from "@untitledui/icons";

interface FloatingAddButtonProps extends React.ComponentProps<"button"> {
  size?: "default" | "fab";
}

export function FloatingAddButton({
  children,
  size = "default",
  ...props
}: FloatingAddButtonProps) {
  return (
    <button
      {...props}
      className={cx(
        `inline-flex shrink-0 items-center justify-center cursor-pointer
      rounded-full bg-brand-600 text-brand-400 hover:bg-primary-dark
      focus-visible:outline focus-visible:outline-offset-2
      focus-visible:outline-primary disabled:opacity-50 disabled:hover:bg-primary`,
        size === "default" && "h-9 w-9 shadow-sm",
        size === "fab" && "h-14 w-14 shadow-lg",
        props.className,
      )}
    >
      <Plus className={size === "default" ? "size-6" : "size-8"} />
      <span className="sr-only">Add</span>
    </button>
  );
}
